export default "__VITE_ASSET__38307b74__"